import { useMemo } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { randomIntFromInterval } from '../../utils';

const Wrapper = styled.div<{
  $darkText: boolean;
  $width: string;
}>`
  display: block;
  height: 2px;
  border-radius: 1px;
  background-color: ${({ $darkText }) => (!$darkText ? '#e1e8ed' : '#C6CAD4')};
  width: ${({ $width }) => `${$width}`};
  min-width: 20px;
`;

interface VaryingWidthLabelProps {
  className?: string;
  darkText?: boolean;
  fixedWidth?: number;
}

export const VaryingWidthLabel: React.ComponentType<VaryingWidthLabelProps> =
  React.memo(({ darkText = false, className, fixedWidth }) => {
    const width = useMemo(() => {
      if (fixedWidth) {
        return `${fixedWidth}px`;
      }
      return `${randomIntFromInterval(15, 100)}%`;
    }, [fixedWidth]);

    return (
      <Wrapper $darkText={darkText} $width={width} className={className} />
    );
  });
